import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PopQuizState {
  replay: boolean;
  nextVideo: boolean;
  showNextVideo: boolean;
  noOfQuestions: number;
  correctQuestions: number;
}

const initialState: PopQuizState = {
  replay: false,
  nextVideo: false,
  showNextVideo: false,
  noOfQuestions: 0,
  correctQuestions: 0,
};

const popSlice = createSlice({
  name: "popQuiz",
  initialState,
  reducers: {
    setReplay: (state, action: PayloadAction<boolean>) => {
      state.replay = action.payload;
    },
    setNextVideo: (state, action: PayloadAction<boolean>) => {
      state.nextVideo = action.payload;
    },
    setShowNextVideo: (state, action: PayloadAction<boolean>) => {
      state.showNextVideo = action.payload;
    },
    setNoOfQuestions: (state, action: PayloadAction<number>) => {
      state.noOfQuestions = action.payload;
    },
    setNoOfCorrectQn: (state, action: PayloadAction<number>) => {
      state.correctQuestions = action.payload;
    },
  },
});
export const {
  setReplay,
  setNextVideo,
  setShowNextVideo,
  setNoOfQuestions,
  setNoOfCorrectQn,
} = popSlice.actions;
export default popSlice.reducer;
